import type { RunStatus } from '@prisma/client';
import { match } from 'ts-pattern';
import {
  IconCircle,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconCircleX,
  IconCircleXFilled,
  IconLoader2,
} from '@tabler/icons-react';
import clsx from 'clsx';
import { Tooltip } from '@mantine/core';

export function RunResultOverviewIcons({ status, value }: { status: RunStatus; value: number }) {
  if (value === 0) {
    return null;
  }

  return (
    <Tooltip
      label={`${value} ${status}`}
      classNames={{ tooltip: 'lowercase' }}
    >
      <div className="relative z-10 flex items-center gap-1 text-sm">
        {match(status)
          .with('PASSED', () => (
            <IconCircleCheckFilled
              size={16}
              className="text-green-600"
            />
          ))
          .with('FAILED', () => (
            <IconCircleXFilled
              size={16}
              className="text-red-500"
            />
          ))
          .with('RUNNING', () => (
            <IconLoader2
              size={16}
              className={clsx(value > 0 && 'animate-spin', 'text-yellow-500')}
            />
          ))
          .with('FLAKY', () => (
            <IconCircleCheck
              size={16}
              className="text-green-700"
            />
          ))
          .with('QUEUED', () => (
            <IconLoader2
              size={16}
              className={clsx(value > 0 && 'animate-spin', 'text-gray-500')}
            />
          ))
          .with('SKIPPED', () => (
            <IconCircle
              size={16}
              className="text-gray-400"
            />
          ))
          .with('CANCELLED', () => (
            <IconCircleX
              size={16}
              className="text-gray-400"
            />
          ))
          .with('ERROR', () => (
            <IconCircleX
              size={16}
              className="text-red-600"
            />
          ))
          .with('RETRYING', () => (
            <IconLoader2
              size={16}
              className={clsx(value > 0 && 'animate-spin', 'text-yellow-600')}
            />
          ))
          .exhaustive()}
        <span className="text-[var(--mantine-color-dimmed)]">{value}</span>
      </div>
    </Tooltip>
  );
}
